/*
 * Copyright 2014-2019 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faGitter } from '@fortawesome/free-brands-svg-icons/faGitter';
import { faStackOverflow } from '@fortawesome/free-brands-svg-icons/faStackOverflow';
import { faStopCircle as farStopCircle } from '@fortawesome/free-regular-svg-icons/faStopCircle';
import { faTimesCircle as farTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';
import {
  faAngleDoubleLeft,
  faCogs,
  faExpand,
  faEye,
  faList,
  faPowerOff,
  faUndoAlt,
} from '@fortawesome/free-solid-svg-icons';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell';
import { faBellSlash } from '@fortawesome/free-solid-svg-icons/faBellSlash';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faCube } from '@fortawesome/free-solid-svg-icons/faCube';
import { faCubes } from '@fortawesome/free-solid-svg-icons/faCubes';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faFrownOpen } from '@fortawesome/free-solid-svg-icons/faFrownOpen';
import { faHeartbeat } from '@fortawesome/free-solid-svg-icons/faHeartbeat';
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faStepBackward } from '@fortawesome/free-solid-svg-icons/faStepBackward';
import { faStepForward } from '@fortawesome/free-solid-svg-icons/faStepForward';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons/faSyncAlt';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons/faUserCircle';
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default FontAwesomeIcon;

library.add(
  //solid
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faBan,
  faBell,
  faBellSlash,
  faBook,
  faBars,
  faCogs,
  faEye,
  faCheck,
  faCube,
  faCubes,
  faDownload,
  faExclamation,
  faExclamationTriangle,
  faExclamationCircle,
  faFilter,
  faFrownOpen,
  faHeartbeat,
  faHistory,
  faInfoCircle,
  faExclamationCircle,
  faHome,
  faList,
  faExpand,
  faMapMarkerAlt,
  faCheckCircle,
  faMinusCircle,
  faChevronRight,
  faChevronDown,
  faPencilAlt,
  faPowerOff,
  faQuestionCircle,
  faSearch,
  faSignOutAlt,
  faStepBackward,
  faStepForward,
  faTimesCircle,
  faTrash,
  faRedo,
  faSyncAlt,
  faUndoAlt,
  faUserCircle,
  faWrench,
  //regular
  farStopCircle,
  farTimesCircle,
  //brands
  faGithub,
  faGitter,
  faStackOverflow,
);
